import { gql, useMutation } from '@apollo/client';
import { HooksAccountLoginMutation, HooksAccountLoginMutationVariables } from '../../generated/graphql.js';

const GRAPHQL_MUTATION = gql`
  mutation hooksAccountLogin($user_name: String!, $password: String!) {
    accountLogin(body: { user_name: $user_name, password: $password }) {
      data {
        uuid
        token
      }
    }
  }
`;

export const useAccountLoginGraphql = () => {
  const [mutation, result] = useMutation<HooksAccountLoginMutation, HooksAccountLoginMutationVariables>(
    GRAPHQL_MUTATION
  );

  const doAction: typeof mutation = async (args) => {
    const action_result = await mutation(args);

    return action_result;
  };

  return {
    doAction,
    result,
  };
};
